// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3V7jD","file":"styles_file__7HOPV"};